"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgWarning(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M12 0l8 16H4zm0 12a1 1 0 100 2 1 1 0 000-2zm1-6h-2l.528 5h.944z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Warning')(SvgWarning);
//# sourceMappingURL=Warning.js.map